import React from 'react'
import InputAdornment from '@mui/material/InputAdornment'
import SearchIcon from '@mui/icons-material/Search'
import TextField from '@mui/material/TextField'
import CancelIcon from '@mui/icons-material/Cancel'
import IconButton from '@mui/material/IconButton'

class SearchInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      search: null,
    }
  }

  handleSearchChange = (e) => {
    this.setState({ search: e.target.value })
    if (!e.target.value) {
      this.props.onSearch(null)
    }
  }

  keyPress = (e) => {
    if (e.keyCode === 13 && this.state.search) {
      this.props.onSearch(this.state.search)
    }
  }

  clear = () => {
    this.setState({ search: null })
    this.props.onSearch(null)
  }

  render() {
    return (
      <TextField
        onKeyDown={this.keyPress}
        id='findevents'
        // label='etsi'
        type='text'
        variant='standard'
        value={this.state.search || ''}
        onChange={this.handleSearchChange}
        InputProps={
          !this.state.search
            ? {
                startAdornment: (
                  <InputAdornment position='start'>
                    <SearchIcon color='disabled' />
                  </InputAdornment>
                ),
              }
            : {
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton onClick={this.clear} edge='end'>
                      <CancelIcon color='disabled' />
                    </IconButton>
                  </InputAdornment>
                ),
              }
        }
      />
    )
  }
}

export default SearchInput
